<router-outlet></router-outlet>

<!-- Global webview authentication modal -->
<app-global-webview-auth-modal></app-global-webview-auth-modal>
